import React from "react";
import SiteSearchBar from "../../common/SiteSearch/SiteSearchBar";

const NavbarSearch = () => (
  <div className="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
    <SiteSearchBar variant="navbar" placeholder="Search…" />
  </div>
);

export default NavbarSearch;
